import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div ...attributes {{did-insert this.registerDropZone}}>\n  {{yield\n    (hash isActive=this.isActive isDraggingAnywhere=this.isDraggingAnywhere)\n  }}\n</div>")